import React, { Fragment } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./pages/Home";
// import CaptainAlphaProfile from "./component/profiles/CaptainAlphaProfile.js";
import Loader from "./component/reusable/Loader.js";

import ScrollToTop from "./component/reusable/ScrollToTop.js";
import { useAuth } from "alpha-ui";
import RedirectSpinner from "./component/reusable/RedirectSpinner.js";
import StudentProfile from "./pages/StudentProfile.js";
import StudentPiq from "./pages/StudentPiq.js";
import TeacherProfile from "./pages/TeacherProfile.js";
import ParentProfile from "./pages/ParentProfile.js";
import HowToUse from "./pages/HowToUse.js";
import ProfileHelp from "./pages/ProfileHelp.js";
import SideSocialIcons from "./component/reusable/SideSocialIcons.js";
import StudentsOfTeacher from "./pages/StudentsOfTeacher.js";
import PaymentPage from "./pages/PaymentPage.js";
import SpokenEnglishHowUse from "./pages/howToUse/SpokenEnglishHowUse.js";
import OLQAnalyseHowUse from "./pages/howToUse/OLQAnalyseHowUse.js";
import SSBMentorHowUse from "./pages/howToUse/SSBMentorHowUse.js";
import MockPsychologyHowUse from "./pages/howToUse/MockPsychologyHowUse.js";
import OIRHowUse from "./pages/howToUse/OIRHowUse.js";
import PhysicalHowUse from "./pages/howToUse/PhysicalHowUse.js";
import MedicalHowUse from "./pages/howToUse/MedicalHowUse.js";
import GroupDiscussionHowUse from "./pages/howToUse/GroupDiscussionHowUse.js";
import PsychologyTestHowUse from "./pages/howToUse/PsychologyTestHowUse.js";
import PPDTHowUse from "./pages/howToUse/PPDTHowUse.js";
import GTOHowUse from "./pages/howToUse/GTOHowUse.js";
import CoursesHowUse from "./pages/howToUse/CoursesHowUse.js";
import MockInterviewHowUse from "./pages/howToUse/MockInterviewHowUse.js";
import CurrentAffairsHowUse from "./pages/howToUse/CurrentAffairsHowUse.js";
import NotesHowUse from "./pages/howToUse/NotesHowUse.js";
import SSBGPTHowUse from "./pages/howToUse/SSBGPTHowUse.js";
import ExerciseTracker from "./component/allExercises/ExerciseTracker.js";
import LecturetteHowUse from "./pages/howToUse/LecturetteHowUse.js";
import NotificationPrompt from "./component/reusable/Notification.js";
import GptSearch from "./component/gptSearch.js";
import CustomVideoPlayer from "./component/gptPages/video.js";
import Interview from "./component/gptPages/Interview.js";
import Lecturette from "./component/gptPages/Lecturette.js";
import GroupDiscussion from "./component/gptPages/GroupDiscussion.js";
import PsychologyTest from "./component/gptPages/PsychologyTest.js";
import SrtAttempt from "./component/gptPages/SrtAttempt.js";
import AiSpokenEnglish from "./component/gptPages/AiSpokenEnglish.js";
import ChapterDetail from "./component/gptPages/ChapterDetail.js";

import MockPPDT from "./component/gptPages/MockPPDT.js";
import InterviewFeedback from "./component/gptPages/InterviewFeedback.js";
import AnitaProfile from "./component/profiles/AnitaProfile.js";

const App = () => {
  const { auth } = useAuth();
  const user = auth?.user;
  const loading = auth?.loading;
  const isAuthenticated = auth?.isAuthenticated;

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <ToastContainer />
          <ScrollToTop />
          <SideSocialIcons />
          <NotificationPrompt />
          <Routes>
            <Route exact path="/" element={<Home />} />
  
            <Route
              path="/"
              element={
                isAuthenticated && user?._id ? <Outlet /> : <RedirectSpinner />
              }
            >
              <Route path="chat" element={<GptSearch />} />
            </Route>
            <Route path="/exercise" element={<ExerciseTracker />} />
            <Route path="/video" element={<CustomVideoPlayer />} />
            <Route path="/interview" element={<Interview />} />
            <Route path="/lecturette" element={<Lecturette />} />
            <Route path="/group-discussion" element={<GroupDiscussion />} />
            <Route path="/feedback" element={<InterviewFeedback />} />
            <Route
              path="/psychology-test-attempt"
              element={<PsychologyTest />}
            />
            <Route path="/srt-practice-test" element={<SrtAttempt />} />
            <Route path="/spoken-english" element={<AiSpokenEnglish />} />
         
            <Route path="/chapter-details/:id" element={<ChapterDetail />} />
        
            <Route path="/profile/chat" element={<AnitaProfile />} />

        
            <Route path="/mock-ppdt" element={<MockPPDT />} />

            {/* Routes For Student Start */}
            <Route
              path="/student"
              element={
                isAuthenticated && user?.role === "11" ? (
                  <Outlet />
                ) : (
                  <RedirectSpinner />
                )
              }
            >
              <Route path="profile" element={<StudentProfile />} />
              <Route path="piq" element={<StudentPiq />} />
              <Route path="how-to-use" element={<HowToUse />} />
              <Route path="payment" element={<PaymentPage />} />
              <Route path="help" element={<ProfileHelp />} />
            </Route>
            {/* Routes For Student Ends */}

            {/* Routes For Teacher Start */}
            <Route
              path="/teacher"
              element={isAuthenticated ? <Outlet /> : <RedirectSpinner />}
            >
              <Route path="profile" element={<TeacherProfile />} />
              <Route path="students" element={<StudentsOfTeacher />} />
              <Route path="help" element={<ProfileHelp />} />
              <Route path="payment" element={<PaymentPage />} />
            </Route>
            {/* Routes For Teacher Ends */}

            {/* Routes For Parent Start */}
            <Route
              path="/parent"
              element={isAuthenticated ? <Outlet /> : <RedirectSpinner />}
            >
              <Route path="profile" element={<ParentProfile />} />
              <Route path="payment" element={<PaymentPage />} />
              <Route path="help" element={<ProfileHelp />} />
            </Route>
            {/* Routes For Parent Ends */}

            {/* HOW TO USE CLASSROOM PAGES STRAT */}
            <Route
              path="/how-use-spoken-en-classroom"
              element={<SpokenEnglishHowUse />}
            />
            <Route
              path="/how-use-olq-analyse-classroom"
              element={<OLQAnalyseHowUse />}
            />
            <Route
              path="/how-use-ssb-mentor-classroom"
              element={<SSBMentorHowUse />}
            />

            <Route path="/how-use-lecturette" element={<LecturetteHowUse />} />

            <Route
              path="/how-use-mock-psychology-classroom"
              element={<MockPsychologyHowUse />}
            />
            <Route path="/how-use-oir-classroom" element={<OIRHowUse />} />
            <Route
              path="/how-use-physical-classroom"
              element={<PhysicalHowUse />}
            />
            <Route
              path="/how-use-medical-classroom"
              element={<MedicalHowUse />}
            />
            <Route
              path="/how-use-group-discussion-classroom"
              element={<GroupDiscussionHowUse />}
            />
            <Route
              path="/how-use-psychology-test-classroom"
              element={<PsychologyTestHowUse />}
            />
            <Route path="/how-use-ppdt-classroom" element={<PPDTHowUse />} />
            <Route path="/how-use-gto-classroom" element={<GTOHowUse />} />
            <Route
              path="/how-use-courses-classroom"
              element={<CoursesHowUse />}
            />
            <Route
              path="/how-use-mock-interview-classroom"
              element={<MockInterviewHowUse />}
            />
            <Route
              path="/how-use-current-affairs-classroom"
              element={<CurrentAffairsHowUse />}
            />
            <Route path="/how-use-notes-classroom" element={<NotesHowUse />} />
            <Route path="/how-use-ssb-gpt" element={<SSBGPTHowUse />} />
            {/* HOW TO USE CLASSROOM PAGES ENDS */}
          </Routes>
        </Fragment>
      )}
    </>
  );
};

export default App;
